import { createFileRoute } from '@tanstack/react-router'

import { ReportsPage } from '@/pages/reports/reports-page'

export const Route = createFileRoute('/_private/reports')({
  component: ReportsPage,
})
